import script from "./SuccessOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessOrder.vue?vue&type=script&setup=true&lang=js"

import "./SuccessOrder.vue?vue&type=style&index=0&id=13675172&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/192.255.151.37/new/tiempos-h55/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13675172"]])

export default __exports__